import React, { useRef, useState } from "react";
import Layout from "../layout/DefaultLayout";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import { useMutation } from "react-query";
import { Controller, useForm } from "react-hook-form";
import api from "../utils/helper";
import { useAlerts } from "../context/AlertContext";
import { URLS } from "../utils/URL";

const AddVendor = () => {
  const location = useLocation();
  const vendorData = location.state?.vendorData;
  const isEdit = location.state?.isEdit;

  const navigate = useNavigate();
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(
    isEdit ? URLS.IMG_URL + vendorData?.profile_img : null
  );
  const { showSuccess, showError } = useAlerts();
  const fileInputRef = useRef(null);
  console.log(vendorData, "location.state");

  // React Hook Form setup
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      vendorName: isEdit ? vendorData.name : "",
      location: isEdit ? vendorData.location : "",
      firstName: isEdit ? vendorData.firstname : "",
      lastName: isEdit ? vendorData.lastname : "",
      email: isEdit ? vendorData.email : "",
      password: "",
      sendInvite: false, // default is false for create
    },
  });

  // const vendorMutation = useMutation(
  //   isEdit ?
  //     (vendorsData) => api.put(`/super-admin/vendor/${vendorData._id}`, vendorsData.formInputs)
  //     :
  //     (vendorsData) => api.post("/super-admin/vendor", vendorsData),
  //   {
  //     onSuccess: (response) => {
  //       showSuccess(response.data?.message || "Vendor added successfully!")
  //       console.log("Vendor added successfully!", response);

  //       setTimeout(() => {
  //         navigate("/vendors");
  //       }, 2000)
  //     },
  //     onError: (error) => {
  //       showError(error?.response?.data?.message || "Failed to add vendor: ")
  //       console.log("Failed to add vendor: " + error.message);
  //     }
  //   });

  const vendorMutation = useMutation(
    isEdit
      ? (vendorsData) =>
          api.put(`/super-admin/vendor/${vendorData._id}`, vendorsData)
      : (vendorsData) => api.post("/super-admin/vendor", vendorsData),
    {
      onSuccess: (response) => {
        showSuccess(
          response.data?.message ||
            (isEdit
              ? "Vendor updated successfully!"
              : "Vendor added successfully!")
        );
        console.log(
          isEdit
            ? "Vendor updated successfully!"
            : "Vendor added successfully!",
          response
        );

        setTimeout(() => {
          navigate("/vendors");
        }, 2000);
      },
      onError: (error) => {
        showError(
          error?.response?.data?.message ||
            (isEdit ? "Failed to update vendor: " : "Failed to add vendor: ")
        );
        console.log(
          (isEdit ? "Failed to update vendor: " : "Failed to add vendor: ") +
            error.message
        );
      },
    }
  );

  const logoMutation = useMutation(
    ({ formData }) => api.upload("/upload", formData, "upload"),
    {
      onSuccess: (response, variables) => {
        const updatedFormInputs = {
          ...variables.formInputs,
          profile_img: response?.data?.data?.url,
        };
        vendorMutation.mutate(updatedFormInputs);
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Error uploading file:");
        console.error("Error uploading file:", error);
      },
    }
  );

  const handleDivClick = () => {
    fileInputRef.current.click(); // Trigger file input click
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = (data) => {
    const formInputs = {
      name: data.vendorName,
      location: data.location,
      firstname: data.firstName,
      lastname: data.lastName,
      email: data.email,
      password: data.password,
      sendInvite: data.sendInvite, // boolean: true/false
    };

    // For edit mode with existing image that's not being changed
    if (isEdit && !logoFile && logoPreview) {
      // Extract just the filename from the full URL path
      const existingImagePath = vendorData?.profile_img;
      formInputs.profile_img = existingImagePath;
      vendorMutation.mutate(formInputs);
    }
    // For new image upload (both in create and edit mode)
    else if (logoFile) {
      const formData = new FormData();
      formData.append("file", logoFile);
      formData.append("courseName", "vendor");
      formData.append("moduleName", data.vendorName);

      logoMutation.mutate({ formData, formInputs });
    }
    // For cases with no image (create mode without image)
    else {
      vendorMutation.mutate(formInputs);
    }
  };

  const handleCancel = () => {
    reset();
    navigate("/vendors");
  };

  return (
    <Layout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <h2 className="heading mb-0 px-3">
          {/* <Link to="/vendors" className="linkHref">
            <span>Bajaj Auto</span>
          </Link>{" "} */}
          <Link to="/vendors" className="linkHref">
            <span className="linkHref"> Vendors</span>
          </Link>
          <span className=" text-light fw-bold">
            <FaArrowRight className="mx-1" /> {isEdit ? "Edit" : "Add New"}
          </span>
        </h2>
      </div>
      <Container
        fluid
        className="main-container college-container mt-0 mt-md-4 ps-auto ps-md-0"
      >
        <Card className="form-card">
          {/* Header Section */}
          <Card.Header className="heading d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h2 className="text-muted venhead mb-0">
                  {/* <Link to="/vendors" className="linkHref">
                    <span>Bajaj Auto</span>
                  </Link>{" "} */}
                  <Link to="/vendors" className="linkHref">
                    <span> Vendors</span>
                  </Link>
                  <span className="venhead fw-bold">
                    <FaArrowRight /> {isEdit ? "Edit " : "Add New"}
                  </span>
                </h2>
              </div>
              <div>
                <Button
                  variant="outline-secondary"
                  className="me-2 btn-sec"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button
                  color="#60B1FF"
                  className="btn-sec"
                  onClick={handleSubmit(onSubmit)}
                  disabled={vendorMutation.isLoading || logoMutation.isLoading}
                >
                  {vendorMutation.isLoading ||
                    (logoMutation.isLoading && <Spinner size="sm" />)}
                  Save & Invite
                </Button>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="mobile-form">
            {/* Vendor Details */}
            <Row className="mb-3">
              <Col md={3} className="px-4 py-2 p-md-2">
                <h3 className="vendorDetails">Vendors Details</h3>
                <p className="basicInfo mb-0">Add vendor's basic info</p>
              </Col>
              <Col md={9}>
                <Form className="p-3 formMain">
                  {/* Vendor Name */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Vendor Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="vendorName"
                      control={control}
                      rules={{ required: "Vendor name is required" }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          placeholder="Enter vendor name"
                          isInvalid={!!errors.vendorName}
                        />
                      )}
                    />
                    {errors.vendorName && (
                      <Form.Control.Feedback type="invalid">
                        {errors.vendorName.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>

                  {/* Upload Logo */}
                  <Form.Group className="mb-3 d-flex uploadProfile">
                    <div>
                      <img src={logoPreview} className="profile-holder" />
                    </div>
                    <div
                      className="p-con d-flex gap-4 p-2 w-100"
                      onClick={handleDivClick}
                    >
                      <div className="text-center w-100">
                        <img
                          src="/images/uploadIcon.png"
                          className="icon-upload"
                        />
                        <p className="upload-text mb-0">
                          <span>Click to upload</span> or drag and drop
                        </p>
                        <p className="text-muted upload-text-small mb-0">
                          SVG, PNG, JPG or GIF (max. 800x400px)
                        </p>
                        <Form.Control
                          type="file"
                          ref={fileInputRef}
                          onChange={handleLogoChange}
                          accept="image/*"
                          className="d-none"
                        />
                      </div>
                    </div>
                  </Form.Group>

                  {/* Location */}
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Controller
                      name="location"
                      control={control}
                      rules={{ required: "Location is required" }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          placeholder="Enter location"
                          isInvalid={!!errors.location}
                        />
                      )}
                    />
                    {errors.location && (
                      <Form.Control.Feedback type="invalid">
                        {errors.location.message}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Form>
              </Col>
            </Row>

            {/* Admin Details */}
            <Row>
              <Col md={3} className="px-4 py-2 p-md-2">
                <h3 className="vendorDetails  ">Admin Details</h3>
                <p className="basicInfo">Add admin user details</p>
              </Col>
              <Col md={9} className="contentdiv">
                <Form className="p-3 formMain">
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          First name <span className="text-danger">*</span>
                        </Form.Label>
                        <Controller
                          name="firstName"
                          control={control}
                          rules={{ required: "First name is required" }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="First name"
                              isInvalid={!!errors.firstName}
                            />
                          )}
                        />
                        {errors.firstName && (
                          <Form.Control.Feedback type="invalid">
                            {errors.firstName.message}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Last name <span className="text-danger">*</span>
                        </Form.Label>
                        <Controller
                          name="lastName"
                          control={control}
                          rules={{ required: "Last name is required" }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              type="text"
                              placeholder="Last name"
                              isInvalid={!!errors.lastName}
                            />
                          )}
                        />
                        {errors.lastName && (
                          <Form.Control.Feedback type="invalid">
                            {errors.lastName.message}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Email <span className="text-danger">*</span>
                    </Form.Label>

                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: "Email is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      }}
                      render={({ field }) => (
                        <InputGroup>
                          <InputGroup.Text className="bg-transparent">
                            <CiMail />
                          </InputGroup.Text>
                          <Form.Control
                            {...field}
                            type="email"
                            placeholder="Enter email"
                            isInvalid={!!errors.email}
                          />
                          {errors.email && (
                            <Form.Control.Feedback type="invalid">
                              {errors.email.message}
                            </Form.Control.Feedback>
                          )}
                        </InputGroup>
                      )}
                    />
                  </Form.Group>

                  {!isEdit && (
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Set Password <span className="text-danger">*</span>
                      </Form.Label>
                      <Controller
                        name="password"
                        control={control}
                        rules={{
                          required: "Password is required",
                          minLength: {
                            value: 8,
                            message: "Password must be at least 8 characters",
                          },
                        }}
                        render={({ field }) => (
                          <Form.Control
                            {...field}
                            type="password"
                            placeholder="Set password"
                            isInvalid={!!errors.password}
                          />
                        )}
                      />
                      {errors.password && (
                        <Form.Control.Feedback type="invalid">
                          {errors.password.message}
                        </Form.Control.Feedback>
                      )}
                    </Form.Group>
                  )}

                  {!isEdit && (
                    <Form.Group className="mb-3">
                      <Controller
                        name="sendInvite"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <Form.Check
                            type="switch"
                            id="invite-email-switch"
                            label="Send Invite Email"
                            className="checktoggle"
                            checked={value}
                            onChange={(e) => onChange(e.target.checked)}
                          />
                        )}
                      />
                      <Form.Text className="text-muted">
                        An invitation will be sent to the teacher with login
                        instructions & password.
                      </Form.Text>
                    </Form.Group>
                  )}
                </Form>
                <div className="">
                  <div className="d-flex flex-column flex-md-row gap-3">
                    <div className="">
                      <Card
                        as={Link}
                        to="/add-student"
                        className="d-flex flex-row gap-2 align-items-center quick-btn text-decoration-none"
                      >
                        <img
                          className="quick-icons"
                          src="./images/addStudent.png"
                        />
                        <h6 className="mb-0">Add Students</h6>
                      </Card>
                    </div>
                    <div className="">
                      <Card
                        as={Link}
                        to="/add-teacher"
                        className="d-flex flex-row gap-2 align-items-center quick-btn text-decoration-none"
                      >
                        <img
                          className="quick-icons"
                          src="./images/addTeacher.png"
                        />
                        <h6 className="mb-0">Add Teachers</h6>
                      </Card>
                    </div>
                    <div className="">
                      <Card
                        as={Link}
                        to="/add-course"
                        className="d-flex flex-row gap-2 align-items-center quick-btn text-decoration-none"
                      >
                        <img
                          className="quick-icons"
                          src="./images/icon (1).png"
                        />
                        <h6 className="mb-0">Add Colleges</h6>
                      </Card>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-end d-lg-none my-2">
              <Button variant="outline-secondary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
                color="#60B1FF"
                className="ms-2 "
                onClick={handleSubmit(onSubmit)}
                disabled={vendorMutation.isLoading || logoMutation.isLoading}
              >
                {vendorMutation.isLoading ||
                  (logoMutation.isLoading && <Spinner size="sm" />)}
                Save & Invite
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
    </Layout>
  );
};

export default AddVendor;
